<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-card
        max-width="340"
        min-width="250"
        class="mb-6 black--text"
        :elevation="hover ? 12 : 2"
        color="white"
       
      >
        <v-img :src="getImgUrl(course.img)"></v-img>

        <v-card-title>
          {{ course.name }}
        </v-card-title>
        <v-card-subtitle class="black--text text--lighten-5">
          {{ course.subtitle }}<br />{{ course.teacher }}
        </v-card-subtitle>
        <v-card-actions>
          <v-btn to="/signUp" color="alert" class="white--text">
            Записаться
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="main" text v-on:click="courseInfo()"> Подробнее </v-btn>
        </v-card-actions>

      </v-card>
    </v-hover>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-text class="text-left pa-6">
          <b>Продолжительность курса: </b>{{ course.inCourse }} <br />
          <b>Занятие: </b>{{ course.duration }} <br />
          <b>Стоимость: </b>{{ course.price }} <br />
          <b>Частота: </b>{{ course.quantity }} <br />
          <b>Возраст: </b> с {{ course.minAge }} лет<br />
          <b>Итоговая работа: </b>{{ course.total }} <br />
          <v-divider></v-divider>
          {{ course.discription }}
        </v-card-text>
         <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn  text v-on:click="courseInfo()"> Закрыть </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "CoursePreview",
  props: {
    course: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    getImgUrl(pic) {
      return require("../assets/images/" + pic);
    },
    courseInfo: function () {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>